import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  usePurchasedGoodsReviewList,
  usePurchasedGoodsReviewStatsRetrieve,
} from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  PaginatedReviewPurchasedGoodList,
  PurchasedGoodReviewStats,
  PurchasedGoodsReviewListParams,
} from '@shared/api/types';

/** Items for review — the full review queue: uncertain-typed goods plus goods
 *  whose match or weight is review-flagged. All are withheld from reporting
 *  (and the Food & Drink / Packaging lists) until resolved. Each row carries a
 *  single derived `reviewReason` (`unclear_item_type` / `unclear_match` /
 *  `unclear_weight`, precedence applied), filterable via `review_reason`. */
export const useGetPurchasedReviewList = (
  params?: PurchasedGoodsReviewListParams,
  { enabled }: { enabled?: boolean } = {}
) =>
  usePurchasedGoodsReviewList<PaginatedReviewPurchasedGoodList>(params, {
    request: useAxiosConfig(),
    query: { keepPreviousData: true, enabled },
  });

/** Excluded-items landing stats: item count + spend per bucket (review /
 *  other), header totals, and the excluded share of all purchase spend. */
export const useGetPurchasedReviewStats = () =>
  usePurchasedGoodsReviewStatsRetrieve<PurchasedGoodReviewStats>({
    request: useAxiosConfig(),
  });
